// The three migration contract errors of the STO GET endpoints (API: app/Utils/tranzilaStoGet.js). They are HTTP 502
// answers with { get_success:false, err_key, code, message, reason }. Whatever the transport wrapper, the code is
// found on the axios rejection (err.response.data), on a bare envelope, or on a resolved response (response.data).
// The screens show ONE approved sentence; the API's own text, the reason and any item data are never displayed.
export const STO_CONTRACT_ERROR_TEXT = 'לא ניתן היה לקרוא את נתוני הוראת הקבע. נדרשת בדיקה ידנית.'

export const STO_CONTRACT_ERROR_CODES = [
    'TRANZILA_STO_RESPONSE_INVALID',
    'TRANZILA_STO_PRODUCT_AMBIGUOUS',
    'TRANZILA_STO_IDENTITY_MISMATCH'
]

export const isStoContractErrorKey = (key: any): boolean =>
    typeof key === 'string' && STO_CONTRACT_ERROR_CODES.indexOf(key) !== -1

export const stoContractErrorOf = (error: any): string | null => {
    if (!error || typeof error !== 'object') return null
    const candidates = [error.response && error.response.data, error.data, error]
    for (let i = 0; i < candidates.length; i++) {
        const data = candidates[i]
        if (!data || typeof data !== 'object') continue
        if (isStoContractErrorKey(data.err_key)) return data.err_key
        if (isStoContractErrorKey(data.code)) return data.code
    }
    return null
}

// Text for a failed STO request: the approved sentence for a contract error, otherwise the screen's own message.
export const stoFailureText = (error: any, fallback: string): string =>
    stoContractErrorOf(error) ? STO_CONTRACT_ERROR_TEXT : fallback

// Text for a stored err_key (tooltips): contract codes get the approved sentence, other keys keep their map entry.
export const stoErrKeyText = (errKey: any, byKey: { [key: string]: string }, fallback: string): string => {
    if (isStoContractErrorKey(errKey)) return STO_CONTRACT_ERROR_TEXT
    const own = typeof errKey === 'string' && Object.prototype.hasOwnProperty.call(byKey, errKey)
    return own && typeof byKey[errKey] === 'string' ? byKey[errKey] : fallback
}
